// ./src/contexts/ErrorReportContext/ErrorReportContext.tsx
//
// A tiny, dependency-free context for "report this error". The PROVIDER (which
// actually renders the feedback drawer) lives in components/features/ErrorReport
// so this file stays pure — it can be imported from anywhere (including generic
// components) without pulling in the feature layer or risking a barrel cycle.

import { createContext, useContext } from "react";

export interface ErrorReportInfo {
  /** Human-readable page where the error happened, e.g. "Tags". */
  page?: string;
  /** The API operation that failed, e.g. "tagList". */
  operation?: string;
  /** Copyable detail block (messages + code) to pre-fill the report with. */
  details: string;
}

export interface ErrorReportContextValue {
  /** Open the feedback flow, pre-filled with the error + where it happened. */
  reportError: (info: ErrorReportInfo) => void;
}

export const ErrorReportContext =
  createContext<ErrorReportContextValue | null>(null);

/** The reporter, or null when no <ErrorReportProvider> is mounted. */
export const useOptionalErrorReport = (): ErrorReportContextValue | null =>
  useContext(ErrorReportContext);
